import { stringToCodePoints } from './util';
import { CHAR_WIDTH } from './constants';
export class TileMap {
    constructor(dim, count = 1) {
        this.dim = dim;
        this.count = count;
        this.tileData = [];
        for (let i = 0; i < count; i++) {
            this.tileData.push({
                codePoint: new Array(dim.w * dim.h).fill(' '.codePointAt(0)),
                colour: new Array(dim.w * dim.h).fill(0)
            });
        }
        ;
    }
    static Copy(tileMap) {
        let copied = new TileMap(tileMap.dim, tileMap.count); // Default value is used automatically if 'tileMap.patchDim' is undefined
        if (tileMap.tileData !== undefined) {
            copied.tileData = JSON.parse(JSON.stringify(tileMap.tileData));
        }
        return copied;
    }
    getIndex(coords) {
        if (coords.x >= 0 && coords.x < this.dim.w && coords.y >= 0 && coords.y < this.dim.h) {
            return coords.y * this.dim.w + coords.x;
        }
        return null;
    }
    getTile(coords, patchIndex = 0) {
        const index = this.getIndex(coords);
        if (index == null) {
            return null;
        }
        let patch = this.tileData[patchIndex];
        if (patch == null) {
            return null;
        }
        return { codePoint: patch.codePoint[index], colour: patch.colour[index] };
    }
    getSplitCoords(globalCoords) {
        return {
            coords: {
                x: globalCoords.x % this.dim.w,
                y: globalCoords.y
            },
            patchIndex: Math.floor(globalCoords.x / this.dim.w),
        };
    }
    setTile(newTileData, coords, patchIndex = 0) {
        const index = this.getIndex(coords);
        if (index === null) {
            return;
        }
        let patch = this.tileData[patchIndex];
        if (patch === null) {
            return null;
        }
        patch.codePoint[index] = newTileData.codePoint;
        patch.colour[index] = newTileData.colour;
    }
    draw(renderer, isEditor = false) {
        for (let i = 0; i < this.count; i++) {
            this.drawSingle(renderer, i, { x: i * this.dim.w * CHAR_WIDTH, y: 0 }, isEditor);
        }
        if (isEditor) {
            renderer.drawGrid(0, 0, this.dim.w * CHAR_WIDTH * this.count, this.dim.h * CHAR_WIDTH, this.dim.w * this.count, this.dim.h);
        }
    }
    drawSingle(renderer, index, point, isEditor = false) {
        let patch = this.tileData[index];
        if (patch !== undefined) {
            renderer.drawCharacters(patch.codePoint, patch.colour, point.x, point.y, 0, 0, this.dim.w, false, false);
        }
        else {
            const blankCodePoint = new Array(this.dim.w * this.dim.h).fill(0);
            const blankColour = new Array(this.dim.w * this.dim.h).fill(0);
            renderer.drawCharacters(blankCodePoint, blankColour, point.x, point.y, 0, 0, this.dim.w, false, false);
        }
        if (isEditor) {
            renderer.drawBox(point.x, point.y, point.x + this.dim.w * CHAR_WIDTH, point.y + this.dim.h * CHAR_WIDTH, -1.5);
            const idCodePoints = stringToCodePoints(index.toString());
            renderer.drawCharacters(idCodePoints, new Array(idCodePoints.length).fill(0), point.x + 2, point.y, 0, 0, 0, true, false);
        }
    }
    getDrawDim() {
        return {
            w: this.count * this.dim.w * CHAR_WIDTH,
            h: this.dim.h * CHAR_WIDTH
        };
    }
}
export class PatchMap {
    constructor(dim) {
        this.dim = dim;
        this.tileData = {
            patchId: new Array(dim.w * dim.h).fill(0),
            transform: new Array(dim.w * dim.h).fill(0)
        };
    }
    static Copy(patchMap) {
        let copied = new PatchMap(patchMap.dim);
        if (patchMap.tileData !== undefined) {
            copied.tileData = JSON.parse(JSON.stringify(patchMap.tileData));
        }
        return copied;
    }
    getIndex(coords) {
        if (coords.x >= 0 && coords.x < this.dim.w && coords.y >= 0 && coords.y < this.dim.h) {
            return coords.y * this.dim.w + coords.x;
        }
        return null;
    }
    getPatch(coords) {
        const index = this.getIndex(coords);
        if (index === null) {
            return null;
        }
        return { patchId: this.tileData.patchId[index], transform: this.tileData.transform[index] };
    }
    setPatch(newTileData, coords) {
        const index = this.getIndex(coords);
        if (index === null) {
            return;
        }
        this.tileData.patchId[index] = newTileData.patchId;
        this.tileData.transform[index] = newTileData.transform;
    }
    getPatchDrawOffset(patchCoords) {
        return {
            x: patchCoords.x * (this.dim.w + 1) * CHAR_WIDTH,
            y: patchCoords.y * (this.dim.h + 1) * CHAR_WIDTH,
        };
    }
    draw(renderer, patchSource, isEditor = false) {
        for (let patchX = 0; patchX < this.dim.w; patchX++) {
            for (let patchY = 0; patchY < this.dim.h; patchY++) {
                const index = this.getIndex({ x: patchX, y: patchY });
                const patchId = this.tileData.patchId[index];
                patchSource.drawSingle(renderer, patchId, { x: patchX * patchSource.dim.w * CHAR_WIDTH, y: patchY * patchSource.dim.h * CHAR_WIDTH }, isEditor);
            }
        }
        if (isEditor) {
            renderer.drawGrid(0, 0, patchSource.dim.w * this.dim.w * CHAR_WIDTH, patchSource.dim.h * this.dim.h * CHAR_WIDTH, this.dim.w, this.dim.h);
            renderer.drawBox(0, 0, patchSource.dim.w * this.dim.w * CHAR_WIDTH, patchSource.dim.h * this.dim.h * CHAR_WIDTH, -1.5);
        }
        //use ABCD etc. to represent patchIds
        /*renderer.drawCharacters(this.tileData.patchId.map(n => n + 0x30), new Array(this.tileData.patchId.length).fill(0), 0, 0, 0, 0, this.dim.w, false);
        if (isEditor) {
            renderer.drawGrid(0, 0, this.dim.w * CHAR_WIDTH, this.dim.h * CHAR_WIDTH, this.dim.w, this.dim.h);
            renderer.drawBox(0, 0, this.dim.w * CHAR_WIDTH, this.dim.h * CHAR_WIDTH, -1.5);
        }*/
    }
    createTileMap(patchSource) {
        let tileMap = new TileMap({ w: patchSource.dim.w * this.dim.w, h: patchSource.dim.h * this.dim.h });
        // Iterate patches
        for (let outerX = 0; outerX < this.dim.w; outerX++) {
            for (let outerY = 0; outerY < this.dim.h; outerY++) {
                let offsetX = outerX * patchSource.dim.w;
                let offsetY = outerY * patchSource.dim.h;
                let patchIndex = this.getPatch({ x: outerX, y: outerY }).patchId;
                // Iterate tiles in patch
                for (let innerX = 0; innerX < patchSource.dim.w; innerX++) {
                    for (let innerY = 0; innerY < patchSource.dim.h; innerY++) {
                        tileMap.setTile(patchSource.getTile({ x: innerX, y: innerY }, patchIndex), { x: innerX + offsetX, y: innerY + offsetY });
                    }
                }
            }
        }
        return tileMap;
    }
    getDrawDim(patchSource) {
        return {
            w: this.dim.w * patchSource.dim.w * CHAR_WIDTH,
            h: this.dim.h * patchSource.dim.h * CHAR_WIDTH
        };
    }
}
